import * as React from 'react';
import ReactJson from 'react-json-view'

const Modal = require('react-modal');

interface Props {
    oldValue: any;
    newValue: any;
    onRef?: any;
}

interface State {
    isOpen: boolean;
}

const customStyles = {
    content: {
        border: 'none',
        backgroundColor: "transparent",
        margin: 'auto',
        overflow: 'hidden',
        height: '70%'
    }
};

class AuditLogChangesModal extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            isOpen: false
        };
    }

    componentDidMount(): void {
        if (this.props.onRef) {
            this.props.onRef(this);
        }
        document.addEventListener('keydown', this.keydownHandler);
    }

    componentWillUnmount(): void {
        document.removeEventListener('keydown', this.keydownHandler);
    }

    keydownHandler = (e) => {
        if (e.code === 'Escape') {
            this.close();
        }
    };

    open = () => {
        this.setState({
            isOpen: true
        });
    };

    close = () => {
        this.setState({
            isOpen: false
        });
    };

    render() {
        const {oldValue, newValue} = this.props;
        return (
            <Modal
                isOpen={this.state.isOpen}
                style={customStyles}
                ariaHideApp={false}
                onRequestClose={this.close}
            >
                <div style={{width: '60%', height: '85%'}}
                     className={"container-fluid"}>
                    <div style={{display: "flex", justifyContent: "space-around"}}>
                        <h4 style={{color: '#F5F5F5'}}>Old Value</h4>
                        <h4 style={{color: '#F5F5F5'}}>New Value</h4>
                    </div>
                    <div className="row" style={{height: '100%', display: 'flex'}}>
                        <div className='col-lg-6 compare-changes' style={{backgroundColor: '#2B2B2B', paddingTop: 10, paddingBottom: 10, overflow: "auto", fontSize: '10pt'}}>
                            <ReactJson style={{background: '#2D3436', fontSize: 13}} enableClipboard={false} theme={'tomorrow'} displayDataTypes={false} src={oldValue} />
                        </div>
                        <div style={{width: 5, height: '100%', backgroundColor: 'rgba(245, 245, 245, 0.64)', marginLeft: 3, marginRight: 3}}/>
                        <div className='col-lg-6 compare-changes' style={{backgroundColor: '#2B2B2B', paddingTop: 10, paddingBottom: 10, overflow: "auto"}}>
                            <ReactJson style={{background: '#2D3436'}} enableClipboard={false} theme={'tomorrow'} displayDataTypes={false} src={newValue} />
                        </div>
                    </div>
                    <button
                        onClick={this.close}
                        className={"btn"}
                        id={'close-modal-btn'}
                        style={{float: "right", marginTop: 5, marginRight: -15}}>
                        <i className="fas fa-times"> Close</i>
                    </button>
                </div>
            </Modal>
        )
    }
}

export default AuditLogChangesModal



// WEBPACK FOOTER //
// ./app/components/bo-core/modals/AuditLogChangesModal.tsx